import React, { useState, useEffect } from 'react';
import disliked from '../../assets/heart-blue-dislike.png';
import liked from '../../assets/heart-blue.png';
import send from '../../assets/send.png';
import ResultText from '../Result/ResultText';
import CardComment from './CardComment';
import Spinner from 'react-spinner-material';
import PubSub from 'pubsub-js'
import uuidv4 from 'uuid/v4'
import Snackbar from '@material-ui/core/Snackbar';

import * as firebase from 'firebase';

export default function CardFriend(props, { history }) {

  const [photo, setPhoto] = useState('');
  const [name, setName] = useState('');
  const [resultName, setResultName] = useState([]);
  const [resultNumber, setResultNumber] = useState('');
  const [friendId, setFriendId] = useState('');
  const [qtComments, setQtComments] = useState(0);
  const [qtLikes, setQtLikes] = useState(0);
  const [finishReadFriend, setFinishReadFriend] = useState(false)
  const [finishReadComments, setFinishReadComments] = useState(false)
  const [comments, setComments] = useState([])
  const [commentText, setCommentText] = useState('')
  const [updateComments, setUpdateComments] = useState(false)
  const [editComment, setEditComment] = useState(false)
  const [commentToEdit, setCommentToEdit] = useState(false)
  const [friendUser, setFriendUser] = useState({})
  const [likeIcon, setLikeIcon] = useState(disliked)
  const [friendLiked, setFriendLiked] = useState({})
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  var arrComments = []

  useEffect(() => {
    if (localStorage.getItem("userId") != '' && localStorage.getItem("userId") !== undefined && localStorage.getItem("userId") !== null) {
      if (!finishReadFriend) {
        const friendId = getHashParams();
        getFriendResult(friendId)
      } else if (!finishReadComments) {
        getComments()
      }

      if (finishReadFriend && finishReadComments && updateComments) {
        setUpdateComments(false)
        getComments()
      }

      if (editComment) {
        setCommentText(commentToEdit.comment)
      }
    } else {
      props.history.push('/home')
    }
  }, [finishReadFriend, finishReadComments, updateComments, commentToEdit, friendLiked])

  function getFriendResult(friendId) {
    firebase.database().ref('/usuarios/' + friendId).once('value').
      then(function (snapshot) {
        if (snapshot != null && snapshot.val() != null) {
          var feito = snapshot.val().resultado.feito || false;
          if (feito) {
            setPhoto(snapshot.val().imagemPerfil || "")
            setName(snapshot.val().nome || "")
            setResultName(snapshot.val().resultado.resultadoPerfilNome || "")
            setResultNumber(snapshot.val().resultado.resultadoPerfilNumero || "")
            setQtComments(snapshot.val().qtComments || 0)
            setQtLikes(snapshot.val().qtLikes || 0)
            if (snapshot.val().whoLiked.indexOf(localStorage.getItem("userId") > -1)) {
              setLikeIcon(liked)
              setFriendLiked(true)
            }
            setFinishReadFriend(true)
            setFriendUser(snapshot.val())
          }
        }
      })
  }

  function actionLike() {
    if (friendLiked) {
      friendUser.qtLikes--;
      friendUser.whoLiked = friendUser.whoLiked.filter(e => e !== localStorage.getItem("userId"));
      if (friendUser.qtLikes < 0) {
        friendUser.qtLikes = 0;
      }
      setQtLikes(friendUser.qtLikes)
      firebase.database().ref('usuarios/' + friendUser.id).set(friendUser)
      setLikeIcon(disliked)
      setFriendLiked(false)
      setToastMessage('Descurtido :(')
      setOpenToast(true)
    } else {
      friendUser.qtLikes++;
      friendUser.whoLiked.push(localStorage.getItem("userId"));
      setQtLikes(friendUser.qtLikes)
      firebase.database().ref('usuarios/' + friendUser.id).set(friendUser)
      console.log("Before try to send notification the device from user is")
      console.log(friendUser.deviceId)
      if (friendUser.deviceId != null && friendUser.deviceId != undefined && friendUser.deviceId != '') {
        //To friend who owner's the result
        const nameFriend = localStorage.getItem("name")
        sendNotification(
          `${nameFriend} curtiu o seu resultado!`,
          `Acesse o seu resultado e veja o que os seus amigos estão comentando!`,
          friendUser.deviceId,
          false
        )
      }
      setLikeIcon(liked)
      setFriendLiked(true)
      setToastMessage('Curtido :)')
      setOpenToast(true)
    }
  }

  function handleGoToDetails() {
    history.push(
      {
        pathname: '/details',
        search: `?type=${resultNumber}`
      })
  }

  function getHashParams() {
    /*
    var url = new URL(window.location.href);
    var friendId = url.searchParams.get("friendId");
    */
    try {
      console.log(props)
      const friendId = props.location.state.friendId
      console.log(friendId)
      setFriendId(friendId)
      return friendId;
    } catch{
      props.history.push('/home')
    }
  }

  function getComments() {
    firebase.database().ref('/User-Likes-And-Comments/Comments/' + getHashParams()).once('value').
      then(function (snapshot) {
        if (snapshot != null && snapshot.val() != null) {
          snapshot.forEach(function (childData) {
            arrComments.push(childData.val())
          });
          arrComments = arrComments.sort((a, b) => parseFloat(a.timestamp) - parseFloat(b.timestamp))
          setComments(arrComments)
          setFinishReadComments(true)
        }
      })
  }

  var mySubscriberUpdateComments = function (msg, data) {
    if (finishReadComments) {
      console.log(msg, data);
      setFinishReadComments(false)
    }
  };

  var mySubscriberEditComment = function (msg, data) {
    if (!editComment) {
      console.log(data);
      setCommentToEdit(findCommentById(data))
      setEditComment(true)
    }
  };

  var mySubscriberReportComment = async function (msg, data) {
    if (!editComment) {
      console.log(data);
      const commentToReport = findCommentById(data)
      console.log('commentToReport')
      console.log(commentToReport)
      firebase.database().ref(`/User-Likes-And-Comments/Comments-Reported/${commentToReport.idComment}`).set(commentToReport)
      setToastMessage('Comentário reportado!')
      setOpenToast(true)
    }
  };

  var mySubscriberDeletedComment = async function (msg, data) {
    setToastMessage('Comentário deletado!')
    setOpenToast(true)
  };

  function findCommentById(idComment) {
    var findedComment = ''
    comments.map(comment => {
      if (comment.idComment.localeCompare(idComment) == 0) {
        console.log("Founded")
        findedComment = comment
      }
    })

    return findedComment
  }

  function sendNotification(title, message, registrationId, manyPersons) {

    var url = ""
    var data = {}
    if (manyPersons) {
      if (registrationId.length > 1) {
        url = "https://teste-eneagrama-api.herokuapp.com/send-notification-all-devices";
        data = {
          'message_title': title,
          'message_body': message,
          'registration_ids': registrationId.toString()
        };
      } else {
        url = "https://teste-eneagrama-api.herokuapp.com/send-notification-device";
        data = {
          'message_title': title,
          'message_body': message,
          'registration_id': registrationId[0].toString()
        };
      }
    } else {
      url = "https://teste-eneagrama-api.herokuapp.com/send-notification-device";
      data = {
        'message_title': title,
        'message_body': message,
        'registration_id': registrationId
      };
    }

    const other_params = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
      method: "POST",
    };

    fetch(url, other_params)
    console.log("Enviando comentário para " + registrationId.toString())
    console.log(url)
    console.log(data)
  }

  function sendComment(e) {
    if (commentText.length > 2) {
      e.preventDefault()
      const uuid = uuidv4();
      if (editComment) {
        console.log("Send text to update")
        firebase.database().ref(`/User-Likes-And-Comments/Comments/${getHashParams()}/${commentToEdit.idComment}`).set(
          {
            comment: commentText,
            idComment: commentToEdit.idComment,
            idUser: commentToEdit.idUser,
            imgUrl: commentToEdit.imgUrl,
            name: commentToEdit.name,
            timestamp: commentToEdit.timestamp,
            userIdWithComment: commentToEdit.userIdWithComment
          }
        )
        setToastMessage('Comentário editado!')
        setOpenToast(true)
        setEditComment(false)
      } else {
        firebase.database().ref('/User-Likes-And-Comments/Comments/' + getHashParams() + '/' + uuid).set({
          comment: commentText,
          idComment: uuid,
          idUser: localStorage.getItem("userId"),
          imgUrl: localStorage.getItem("userPicture"),
          name: localStorage.getItem("name"),
          timestamp: Date.now().toString(),
          userIdWithComment: getHashParams()
        })
        friendUser.qtComments++;
        firebase.database().ref('usuarios/' + friendUser.id).set(friendUser)
        const nameFriend = localStorage.getItem("name")
        //To friend who owner's the result
        if (friendUser.deviceId != null && friendUser.deviceId != undefined && friendUser.deviceId != '') {
          sendNotification(
            `${nameFriend} enviou um comentário!`,
            `Acesse o seu resultado no app e veja o comentário`,
            friendUser.deviceId,
            false
          )
        }
        //To friends who commented in this result
        getFriendsAndSendNotification(friendUser)
        setToastMessage('Comentário enviado!')
        setOpenToast(true)
      }
      setCommentText('')
      setFinishReadComments(false)
    } else {
      setToastMessage('Comentário muito curto!')
      setOpenToast(true)
    }
  }

  async function getUsersFriend(idUser) {
    var deviceId = ''
    await firebase.database().ref('/usuarios/' + idUser).once('value').then(function (snapshot) {
      console.log("Getting users friend data!")
      console.log(snapshot.val())
      deviceId = (snapshot.val() && snapshot.val().deviceId) || '';
    })
    console.log("device id")
    console.log(deviceId)
    return deviceId
  }

  function checkIfDeviceExists(resgistrationId, registrationIds, friendIdWhoOwnersTheResult, myDevice) {
    var index = 0
    for (index = 0; index < registrationIds.length; index++) {
      if (resgistrationId == registrationIds[index] || resgistrationId == friendIdWhoOwnersTheResult || resgistrationId == myDevice) {
        console.log("Registration id canot be added")
        return true;
      }
    }
    return false
  }

  async function getFriendsAndSendNotification(friendUser) {
    console.log("getFriendsAndSendNotification")
    const registrationIds = []
    var indexComment = 0
    for (indexComment = 0; indexComment < comments.length; indexComment++) {
      const resgistrationId = await getUsersFriend(comments[indexComment].idUser)
      if (resgistrationId != null && resgistrationId != undefined && resgistrationId != '') {
        if (!checkIfDeviceExists(resgistrationId, registrationIds, friendUser.deviceId, localStorage.getItem('deviceId'))) {
          registrationIds.push(resgistrationId)
        }
      }
    }
    console.log("registrationIds founded")
    console.log(registrationIds)

    if (registrationIds.length > 0) {
      //To friend who owner's the result
      const nameFriend = localStorage.getItem("name")
      sendNotification(
        `Novo comentário de ${nameFriend}`,
        `${nameFriend} comentou no resultado de ${friendUser.nome}`,
        registrationIds,
        true
      )
    }
  }

  function handleChange(e) {
    setCommentText(e.target.value);
  }

  PubSub.subscribe('Update-Comments', mySubscriberUpdateComments);
  PubSub.subscribe('Edit-Comment', mySubscriberEditComment);
  PubSub.subscribe('Report-Comment', mySubscriberReportComment);
  PubSub.subscribe('Deleted-Comment', mySubscriberDeletedComment);

  function handlShowToast() {
    setOpenToast(false)
  }

  function goToHome(){
    props.history.push('/friendsList')
  }

  const items = comments.map((item) => {
    return (<li key={item.idComment} className='space-between-cards'>
      <CardComment
        imgUrl={item.imgUrl}
        name={item.name}
        idUser={item.idUser}
        idComment={item.idComment}
        timestamp={item.timestamp}
        userIdWithComment={item.userIdWithComment}
        friendUser={friendUser}
        comment={item.comment}>
      </CardComment>
    </li>)
  });

  return (
    <div>
      <div onClick={goToHome} className='container-arrow'>
        <i className="left"></i>
        <p className='text-back'>Voltar</p>
      </div>
      <div className='friend-name-container text-card'>
        <span className='photo-container'>
          <img className='photo-friend' src={photo} alt="photo friend" />
        </span>
        <div>
          <p className='text-name-friend-result'>{name}</p>
          <p className='text-name-perfil-result'>{ResultText.type_and_name[resultNumber - 1]}</p>
        </div>
      </div>
      <div>
        <p className="result-description"> {ResultText.resume[resultNumber - 1]} </p>
        <button type="submit" className="btn-details" onClick={handleGoToDetails} value={6}>Detalhes do Resultado</button>
      </div>
      <div className='friend-name-container text-card comments-like'>
        <p className='text-subtitle-comment'>Comentários</p>
        <div className='friend-name-container text-card'>
          <span className='photo-container'>
            <img className='icon-heart' src={likeIcon} alt="like" onClick={actionLike} />
          </span>
          <div>
            <p className='text-icon-like'>{qtLikes}</p>
          </div>
        </div>
      </div>
      <form>
        <div className='friend-name-container text-card'>
          <input type="text" onChange={handleChange} value={commentText} className='comment-input' placeholder="Fazer comentário" />
          <span className='photo-container'>
            <img width='35' height='35' className='icon-send' src={send} alt="send" onClick={sendComment} />
          </span>
        </div>
      </form>
      <span className='spinner-friends' id='load'>
        <Spinner size={60} spinnerColor={"#449AE2"} visible={!finishReadComments} />
      </span>
      <div>
        <ul>{items}</ul>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        key={'bottom,center'}
        open={openToast}
        autoHideDuration={2000}
        onClose={handlShowToast}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={<span id="message-id">{toastMessage}</span>}
      />
    </div >
  )
}